<div class="row container-message-row">
  <div class="container-message">
    @if (title) {
      <div [class]="options.titleClass" [attr.aria-label]="title" class="custom-title">
        {{ title }}
      </div>
    }
    @if (message && options.enableHtml) {
      <div
        role="alertdialog"
        aria-live="polite"
        class="custom-message"
        [ngClass]="options.messageClass"
        [innerHTML]="message"
      ></div>
    }
    @if (message && !options.enableHtml) {
      <div
        role="alertdialog"
        aria-live="polite"
        class="custom-message"
        [ngClass]="options.messageClass"
        [attr.aria-label]="message"
        >
        {{ message }}
      </div>
    }
  </div>
  <div class="text-right">
    @if (options.closeButton) {
      <button (click)="remove()" class="close-button" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>
</div>
@if (options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width + '%'"></div>
  </div>
}
